"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSize = setSize;
var ActionTypes = require("../actionTypes/viewport");
function setSize(size) {
    return {
        type: ActionTypes.SET_SIZE,
        payload: size
    };
}
